import { canExposeInternals } from 'utils/development';
import Socket from './SignalingSocket';

export { Socket };

export * from './eventMap';
export * from './roomOnlyEvents';
export * from './types';

export const SignalingSocket = new Socket();

// Uses lazy import of SignalingSocket to break circular dependency.
export const getSignalingSocket = (): typeof SignalingSocket => {
  // eslint-disable-next-line
  const { SignalingSocket: socket } = require('services/signaling');
  return socket;
};

if (canExposeInternals()) {
  window.Signaling = SignalingSocket;
}
